export default __webpack_public_path__ + "static/media/facebook.760b14e8.svg";